// contextProvider.js
import React from "react";

const ContextProvider = React.createContext();

export default ContextProvider;
